export default __webpack_public_path__ + "static/media/it-webinar.1f0384cb.jpg";